<template>
  <div id="app">
    <transition name="component-fade" mode="out-in">
      <router-view />
    </transition>
    <prompt-modal :parameters="promptModalData" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PromptModal from "@/components/PromptModal.vue";
import "bootstrap-icons/font/bootstrap-icons.css";

export default {
  components: {
    PromptModal
  },
  data() {
    return {
      timerCount: 3600,
      promptModalData: {
        title: "Oops!",
        message: "",
        buttonText: "OK"
      }
    };
  },
  watch: {
    maintenance: function() {
      if (this.maintenance && !this.$route.path.includes("maintenance")) {
        this.$router.push(`/${this.$route.params.subdomain}/maintenance`);
      }
    },
    subdomain(subdomain) {
      // transferred from watch: $route(to) if (to.name != "404")
      if (subdomain && this.$route.name !== "404") {
        this.$store.commit("merchant/SET_SUBDOMAIN", subdomain);
        this.$store.dispatch("merchant/fetchCustomerPortalToken").then(() => {
          this.$store.dispatch("merchant/fetchMerchantSettings");
          this.$store.dispatch("merchant/fetchMerchantMaintenance");

          if (!this.iconsAndLogos) this.initializeFavicon();
        });
        this.$nextTick(() => {
          if (this.subdomain === "ucoin") {
            document.title = "U-COIN | Unilever's Reward Program";
          }
        });
      }
    },
    customerPortalToken(token) {
      if (token) {
        this.getWebDesign();
        this.getStoreDetails()
      }
    }
  },
  computed: {
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken,
      maintenance: state => state.maintenance
    }),
    ...mapState("design", ["iconsAndLogos"]),
    ...mapGetters({
      homeWebLayout: "design/homeWebLayout"
    }),
    subdomain: {
      get() {
        return this.$route.params.subdomain;
      },
      set(subdomain) {
        return subdomain;
      }
    }
  },
  methods: {
    async initializeFavicon() {
      await this.$store.dispatch("design/getIconsAndLogos", {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        }
      });

      if (this.iconsAndLogos && this.iconsAndLogos.favicon)
        document.getElementById("favicon").href = this.iconsAndLogos.favicon;
    },
    getWebDesign() {
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        }
      };
      this.$store.dispatch("estore/getWebDesign", request);
    },
    getStoreDetails() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        }
      };
      this.$store.dispatch("estore/getStoreDetails", request);
    }
  },
  metaInfo() {
    return {
      title: this.homeWebLayout["snippet_details.title"]
        ? this.homeWebLayout["snippet_details.title"]
        : "RUSH E-Store",
      meta: [
        {
          name: "description",
          content: this.homeWebLayout["snippet_details.description"]
            ? this.homeWebLayout["snippet_details.description"]
            : "RUSH E-Store"
        }
      ]
    };
  },
  mounted() {
    this.$root.$on("showPromptModal", parameters => {
      this.promptModalData = { ...this.promptModalData, ...parameters };
      this.$root.$emit("bv::show::modal", "prompt-modal");
    });
  }
};
</script>
